<div class="group" *ngIf="!group?.hidden && group.fields?.data?.length">
  <div class="title" *ngIf="group.title">{{group.title}}</div>
  <div class="fields">
    <form-field [field]="field" [formGroup]="formGroup" *ngFor="let field of group.fields?.data" [readonly]="readonly" [params]="params"></form-field>
  </div>
</div>
